import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { AuthMainLayout } from "./auth-main.layout";
import { AuthHeaderLayout } from "./auth-header-layout";
import { ROUTES } from "../../consts/routes.consts";
import { useAuth } from "./useAuth";
import { useEffect } from "react";
export const AuthLayout = () => {
    const location = useLocation();
    const auth = "Auth";
    const navigate = useNavigate();
    const { isLoggedIn } = useAuth();
    useEffect(() => {
        const isPublicRoute = [ROUTES.HOME].includes(location.pathname);
        if (isLoggedIn && isPublicRoute) {
            navigate(ROUTES.DASHBOARD, { replace: true });
        }
    }, [isLoggedIn, location.pathname, navigate]);

    const isDashboardPage =
        location.pathname === ROUTES.DASHBOARD ||
        location.pathname === ROUTES.ACCOUNT ||
        location.pathname === ROUTES.SUBMIT_A_SONG_PLAYLIST;
    const isSubmitPage =
        location.pathname === ROUTES.SUBMIT_A_SONG ||
        location.pathname === ROUTES.SUBMIT_A_SONG_1 ||
        location.pathname === ROUTES.SUBMIT_A_PLAYLIST ||
        location.pathname === ROUTES.CONFIRM_PLAYLIST;
    return (
        <Box sx={{ display: "flex",flexDirection: 'column' }}>
            <AuthHeaderLayout
                auth={auth}
                isDashboardPage={isDashboardPage}
                isSubmitPage={isSubmitPage}
            />

            <AuthMainLayout>
                <Outlet />
            </AuthMainLayout>
        </Box>
    );
};
